<template>
  <div class="sales-rep-widget-scroll table-responsive p-3">
    <table class="table table-bordered table-sm sales-rep-widget-table mb-0">
      <thead>
        <tr>
          <th>Date Sold</th>
          <th>Org Name</th>
          <th>Contract Num</th>
          <th>U4B Status</th>
          <th
            class="sales-rep-sortable-th"
            @click="$emit('sort', 'sc_forecast_total_commission')"
          >
            SC Forecast Commission
            <i :class="sortIconClass('sc_forecast_total_commission')"></i>
          </th>
          <th>Department to Resolve</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody v-if="items.length">
        <tr v-for="item in items" :key="item.id">
          <td>{{ formatDate(item.date_sold) }}</td>
          <td>{{ item.organization_name || '—' }}</td>
          <td>
            <router-link
              v-if="item.id"
              :to="contractLink(item)"
              class="text-teal"
            >
              {{ item.contract_number || '—' }}
            </router-link>
            <span v-else>{{ item.contract_number || '—' }}</span>
          </td>
          <td>{{ item.u4b_status || '—' }}</td>
          <td class="text-end">{{ formatCurrency(item.sc_forecast_total_commission) }}</td>
          <td class="sales-rep-wrap-cell">
            <div class="sales-rep-cell-content">{{ item.department_to_resolve || '—' }}</div>
          </td>
          <td class="sales-rep-desc-cell">
            <div class="sales-rep-cell-content sales-rep-cell-content--wide">{{ item.comment || '—' }}</div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7" class="text-center text-muted py-3">No issue contracts</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SalesRepIssueContractsTable',
  props: {
    items: { type: Array, default: () => [] },
    sortBy: { type: String, default: 'date_of_sale' },
    sortDir: { type: String, default: 'desc' },
  },
  emits: ['sort'],
  setup(props) {
    const formatDate = (value) => {
      if (!value) return '—';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('en-GB');
    };

    const formatCurrency = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n)) return '£0.00';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);
    };

    const contractLink = (item) => ({
      path: `/crm/edit-contract/${item.id}`,
      query: { for: 'contracts' },
    });

    const sortIconClass = (column) => {
      if (props.sortBy !== column) return 'ti ti-selector text-muted ms-1';
      return props.sortDir === 'asc'
        ? 'ti ti-sort-ascending ms-1'
        : 'ti ti-sort-descending ms-1';
    };

    return { formatDate, formatCurrency, contractLink, sortIconClass };
  },
};
</script>
